import { expose } from 'comlink';
  export const syncFiles=async(url,files)=>{const ret=[];for(const file of files){const body=new FormData();const blob=await(await fetch(file.data)).blob();const key="idb:".concat(file.id);body.append(key,blob,"".concat(file.id));try{const response=await fetch(url,{method:'POST',body});if(response.status===200){ret.push(file.id);}}catch(errorSync){console.error(errorSync);}}return ret;};;
  expose(
    Object.keys(__webpack_exports__).reduce(function(r,k){
      if (k=='__esModule') return r;
      r[k] = __webpack_exports__[k];
      return r
    },{})
  )